import React, { useRef, useCallback, useEffect } from 'react';
import SetCard from './SetCard';
import ItemCard from './ItemCard';
import ItemCardSkeleton from './ItemCardSkeleton';
import './SetsList.css';

const SetsList = ({ sets, lang = 'fr', dense = false, skeletonCount = 0, onLastSetVisible, onSetClick, onItemClick, onTooltipShow, onTooltipHide, onSetTooltipShow, onSetTooltipHide, preferredSlotId = null, showWeaponDamage = false, pinnedItem = null, pinnedWeaponMaging = null, pinnedItemMaging = null, onPinnedClick = null }) => {
    const observer = useRef();

    const onLastSetVisibleRef = useRef(onLastSetVisible);
    useEffect(() => {
        onLastSetVisibleRef.current = onLastSetVisible;
    }, [onLastSetVisible]);

    const lastSetRef = useCallback(node => {
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && onLastSetVisibleRef.current) {
                observer.current.disconnect();
                onLastSetVisibleRef.current();
            }
        });

        if (node) observer.current.observe(node);
    }, []);

    return (
        <div className={`sets-list${dense ? ' results-list--dense' : ''}`}>
            {pinnedItem && (
                <ItemCard
                    key="pinned-equipped"
                    item={pinnedItem}
                    lang={lang}
                    dense={dense}
                    isEquipped
                    weaponMaging={pinnedWeaponMaging}
                    itemMaging={pinnedItemMaging}
                    onEquippedClick={onPinnedClick}
                    preferredSlotId={preferredSlotId}
                    showWeaponDamage={showWeaponDamage}
                    onTooltipShow={onTooltipShow}
                    onTooltipHide={onTooltipHide}
                />
            )}
            {sets.map((set, index) => {
                const isLastSet = index === sets.length - 1;
                const setKey = set?.id || `set-${index}`;
                return <SetCard
                    key={setKey}
                    set={set}
                    lang={lang}
                    dense={dense}
                    onSetClick={onSetClick}
                    onItemClick={onItemClick}
                    onTooltipShow={onTooltipShow}
                    onTooltipHide={onTooltipHide}
                    onSetTooltipShow={onSetTooltipShow}
                    onSetTooltipHide={onSetTooltipHide}
                    preferredSlotId={preferredSlotId}
                    ref={isLastSet ? lastSetRef : null}
                />
            })}
            {Array.from({ length: skeletonCount }, (_, i) => (
                <ItemCardSkeleton key={`skeleton-${i}`} dense={dense} />
            ))}
        </div>
    );
};

export default SetsList;
